/* ============================= E X P O R T ============================= */

export default {
  name: 'CheckCircle',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary',
        'green'
      ]
    }
  }
}
